import { useMemo } from "react";
import { MONTH_WEEKS } from "@repo/utils";
import { CELL_WIDTHS } from "@utils";
import { useEstimateStructure } from "@tools";

export const useTimelineBarChartWidth = ({
  isDraggable,
  startWeek,
  endWeek,
  startMonth,
  endMonth,
  offsetLeft: oL,
  offsetRight: oR,
}) => {
  
  const structure = useEstimateStructure();
  
  const { settings, totalDevelopmentTime } = structure;
  const { expandedTimelineMonths } = settings;
  
  const exceeds = useMemo(() => (
    endMonth > totalDevelopmentTime || endWeek >= totalDevelopmentTime*MONTH_WEEKS
  ), [totalDevelopmentTime, endMonth, endWeek]);
  
  const offsetLeft = useMemo(() => {
    if(isDraggable)
      return 0;
    const startMonthExpanded = expandedTimelineMonths?.get((startMonth + 1).toString());
    
    return (
      startMonthExpanded
        ? 0
        : (
        typeof oL === "number" ? oL : startWeek%4
      ) / 4 * CELL_WIDTHS.VALUE.SMALL
    );
  }, [ oL, isDraggable, expandedTimelineMonths, startMonth, startWeek ]);
  
  const offsetRight = useMemo(() => {
    if(isDraggable)
      return 0;
    const endMonthExpanded = expandedTimelineMonths?.get((endMonth + 1).toString());
    
    return (
      endMonthExpanded
        ? 0
        : (
        typeof oR === "number" ? oR : (3 - endWeek%4)
      ) / 4 * CELL_WIDTHS.VALUE.SMALL
    );
  }, [ oR, isDraggable, expandedTimelineMonths, endMonth, endWeek ])
  
  const width = useMemo(() => {
    if(isDraggable)
      return CELL_WIDTHS.VALUE.SMALL;
    const maxEndMonth = Math.min(totalDevelopmentTime, endMonth);
    
    const startMonthExpanded = expandedTimelineMonths?.get((startMonth + 1).toString());
    const endMonthExpanded = expandedTimelineMonths?.get((endMonth + 1).toString());
    const expandedMonths = structure.settings.expandedTimelineMonthsBetween(startMonth, maxEndMonth);
    const expandedWeeks = startMonthExpanded && startMonth === endMonth
      ? ( endWeek - startWeek + 1 )
      : (
        expandedMonths * 4 - (
          (startMonthExpanded ? startWeek%4 : 0) +
          (endMonthExpanded ? (3 - (endWeek%4)) : 0)
        )
      );
    
    const months = maxEndMonth - startMonth + 1 - expandedMonths;
    
    return months * CELL_WIDTHS.VALUE.SMALL + expandedWeeks * CELL_WIDTHS.VALUE.XXSMALL
  }, [ structure.settings, isDraggable, expandedTimelineMonths, startMonth, endMonth, startWeek, endWeek, totalDevelopmentTime ]);
  
  return {
    exceeds,
    offsetLeft,
    offsetRight,
    width,
  }
}